import React from 'react';
import { Brain, Cloud, Users } from 'lucide-react';

const reasons = [
  {
    icon: Brain,
    title: "Claude Certified Architect",
    description: "AI workflows designed and built by a Claude Certified Architect, not a chatbot bolted onto the tools you already have.",
    iconClass: 'text-accent-400'
  },
  {
    icon: Cloud,
    title: "Built to Survive Production",
    description: "A decade of keeping other people's systems online is why what we build ships with evaluation, logging and alerting from day one, wherever it runs.",
    iconClass: 'text-cloud-400'
  },
  {
    icon: Users,
    title: "Enablement, Not Dependency",
    description: "Your engineers keep working this way after we go. We set up the standards, the safeguards and the automated checks, then measure what actually shipped rather than who logged in.",
    iconClass: 'text-gray-400'
  }
];

const WhyChooseUsSection = () => {
  return (
    <div id="why" className="scroll-mt-20 bg-gray-900 py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-measure">
          <h2 className="font-display text-display-md font-bold text-white sm:text-display-lg">
            Why Kult.io
          </h2>
          <p className="mt-4 text-lg text-gray-300">
            Two practices, one team: AI agents that finish real work, and ten years of production AWS.
          </p>
        </div>

        <div className="mt-14 grid gap-x-10 gap-y-10 md:grid-cols-3">
          {reasons.map((reason) => {
            const IconComponent = reason.icon;
            return (
              <div key={reason.title} className="border-t border-gray-700 pt-6">
                <IconComponent className={`h-5 w-5 ${reason.iconClass}`} aria-hidden="true" />
                <h3 className="mt-4 font-display text-lg font-medium text-white">{reason.title}</h3>
                <p className="mt-2 text-gray-400">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUsSection;